import React from "react";

// DW Investment Group logo — bar chart + swooshing arrow.
// Greens / gold / red bars and an orange arrow per the brand board.
export const Logo = ({ size = 40, withWordmark = true, dark = false }) => {
  const labelColor = dark ? "#FFFFFF" : "#000000";
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="DW Investment Group"
      >
        <ellipse cx="32" cy="34" rx="26" ry="10" fill="none" stroke="#000" strokeWidth="2" />
        <rect x="20" y="22" width="6" height="18" fill="#00A651" />
        <rect x="29" y="16" width="6" height="24" fill="#E88C2F" />
        <rect x="38" y="20" width="6" height="20" fill="#ED1C24" />
        <path
          d="M10 44 Q 32 18 56 22 L 50 16 M 56 22 L 50 28"
          stroke="#F26522"
          strokeWidth="3"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      {withWordmark && (
        <div className="leading-tight">
          <div className="font-heading font-bold text-base sm:text-lg" style={{ color: labelColor }}>
            DW Investment Group
          </div>
          <div className="font-sub text-[11px] sm:text-xs" style={{ color: dark ? "#cbd5e1" : "#475569" }}>
            Insuring Your Future…Today
          </div>
        </div>
      )}
    </div>
  );
};

export default Logo;
